import {
	merge,
	cloneDeep
} from 'lodash';

export default {
	SET_STUDENTS_LIST(state, payload) {
		state.list = payload;
	}, SET_STUDENT(state, payload) {
		state.selected = payload;
	}, SET_STUDENT_STATUS(state, payload) {
		state.list = merge(cloneDeep(state.list), payload);
	}
};



// WEBPACK FOOTER //
// ./sources/domains/student/mutations.js